import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { NEVER, Observable, Subject, tap } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class loaderInterceptor implements HttpInterceptor {
  isLoading = new Subject<boolean>();
  constructor( private spinner :NgxSpinnerService  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.spinner.show();
      return next.handle(request).pipe(
        tap(
          (req:any) => {
            if (req instanceof HttpResponse) {
              this.spinner.hide();
            }
          },
          (err:any) => {
            this.spinner.hide();
          }
        )
      );
    
  }
}
